import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { translate } from 'react-i18next';
import Select from 'react-select';
import 'react-select/dist/react-select.css';
import { REGIONS, getRegionByCode } from '../constants/regions';

class RegionDropdown extends Component {
  constructor(props) {
    super(props);
    const currentLang = props.i18n.language || 'en-gb';
    this.state = {
      selectedRegion: getRegionByCode(currentLang) || getRegionByCode('en-gb'),
    };
  }

  handleRegionChange = (selectedOption) => {
    if (selectedOption && selectedOption.value !== this.state.selectedRegion.code) {
      // Change the URL to the new locale but preserve query parameters
      const currentSearch = window.location.search; // e.g., "?distributor"
      const newPath = `/${selectedOption.value}${currentSearch}`;
      window.location.href = newPath;
    }
  };

  // Render option in dropdown menu
  optionRenderer = (option) => {
    return (
      <div className="region-option">
        <div className="region-flag">
          <img src={option.flagImage} alt={option.label} />
        </div>
        <span className="region-label">{option.label}</span>
      </div>
    );
  };

  // Render selected value
  valueRenderer = (option) => {
    return (
      <div className="region-value">
        <div className="region-flag">
          <img src={option.flagImage} alt={option.label} />
        </div>
        <span className="region-label">{option.label}</span>
      </div>
    );
  };

  // Custom chevron-down icon
  arrowRenderer = () => (
    <svg
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="region-chevron"
    >
      <path
        d="M6 9L1.5 4.5L2.55 3.45L6 6.9L9.45 3.45L10.5 4.5L6 9Z"
        fill="#FFFFFF"
      />
    </svg>
  );

  render() {
    const options = REGIONS.map(region => ({
      value: region.code,
      label: region.label,
      flagImage: region.flagImage,
    }));

    const currentValue = options.find(
      option => option.value === this.state.selectedRegion.code
    );

    return (
      <div className="region-dropdown">
        <Select
          className="region-select"
          clearable={false}
          searchable={false}
          value={currentValue}
          options={options}
          onChange={this.handleRegionChange}
          optionRenderer={this.optionRenderer}
          valueRenderer={this.valueRenderer}
          arrowRenderer={this.arrowRenderer}
        />
      </div>
    );
  }
}

export default withRouter(translate('translations')(RegionDropdown));
